import { render, staticRenderFns } from "./user.vue?vue&type=template&id=8407991e&scoped=true"
import script from "./user.vue?vue&type=script&lang=ts"
export * from "./user.vue?vue&type=script&lang=ts"
import style0 from "./user.vue?vue&type=style&index=0&id=8407991e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8407991e",
  null
  
)

export default component.exports